module.exports = __webpack_public_path__ + "img/knue_main2.4d62dc26.jpg";